import { IconBulb } from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";

const SkillsCard = ({ primarySkills, secondarySkills }) => {
  return (
    <Card icon={IconBulb} title="Skills">
      <div className={styles.skillList}>
        {primarySkills?.map((s) => (
          <span key={s} className={styles.skillChip}>
            {s}
          </span>
        ))}
      </div> <br />
      <div className={styles.skillList}>
        {secondarySkills?.map((s) => (
          <span key={s} className={styles.skillChip}>
            {s}
          </span>
        ))}
      </div>
    </Card>
  );
};

export default SkillsCard;
